import * as React from "react";

export function MobileIcon(props: Readonly<React.SVGProps<SVGSVGElement>>) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path d="M21.333 1.33301H10.6663C8.82634 1.33301 7.33301 2.82634 7.33301 4.66634V27.333C7.33301 29.173 8.82634 30.6663 10.6663 30.6663H21.333C23.173 30.6663 24.6663 29.173 24.6663 27.333V4.66634C24.6663 2.82634 23.173 1.33301 21.333 1.33301ZM15.9997 29.333C14.893 29.333 13.9997 28.4397 13.9997 27.333C13.9997 26.2263 14.893 25.333 15.9997 25.333C17.1063 25.333 17.9997 26.2263 17.9997 27.333C17.9997 28.4397 17.1063 29.333 15.9997 29.333ZM21.9997 23.9997H9.99967V5.33301H21.9997V23.9997Z" fill="currentColor"/>
    </svg>
  );
}
